import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  CheckCircle, 
  ShoppingBag,
  Package,
  ArrowRight
} from 'lucide-react';

const OrderConfirmation = () => {
  const { orderNumber } = useParams();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-auto px-4">
        {/* Success Card */}
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 text-green-600 rounded-full mb-6">
            <CheckCircle className="w-10 h-10" />
          </div>
          
          {/* Success Message */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Ordine Confermato!</h1>
          <p className="text-gray-600 mb-2">
            Grazie per il tuo ordine. Ti abbiamo inviato una conferma via email.
          </p>
          
          {/* Order Number */}
          {orderNumber && (
            <p className="text-sm text-gray-500 mb-8">
              Numero ordine: <span className="font-medium">{orderNumber}</span>
            </p>
          )}

          {/* Action Buttons */}
          <div className="space-y-3">
            {/* View Orders Button */}
            <Link
              to="/dashboard"
              className="w-full inline-flex items-center justify-center px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition-colors"
            >
              <Package className="w-5 h-5 mr-2" />
              Visualizza i Tuoi Ordini
            </Link>

            {/* Create Another Order Button */}
            <Link
              to="/creator"
              className="w-full inline-flex items-center justify-center px-6 py-3 bg-white text-purple-600 font-semibold rounded-lg border border-purple-600 hover:bg-purple-50 transition-colors"
            >
              <ShoppingBag className="w-5 h-5 mr-2" />
              Crea un Altro Liquore
            </Link>

            {/* Home Button */}
            <Link
              to="/"
              className="w-full inline-flex items-center justify-center px-6 py-2 text-gray-600 font-medium hover:text-purple-600 transition-colors"
            >
              <ArrowRight className="w-4 h-4 mr-1" />
              Torna alla Homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;